<template>
    <div>
        <main class="layoutContent">
                <!-- Encabezado contenido principal -->
                <header class="page-header">
                    <div class="container pt-2">
                        <div class="row align-items-center justify-content-between">
                            <div class="col-auto pt-1">
                                <h1 class="page-header--title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                        <path
                                            d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    VACANTES  
                                </h1>
                                <p class="page-header--subtitle">
                                    Plan de Vacaciones {{ xplan }}
                                </p>
                            </div>
                            <div class="col-12 col-xl-auto mt-4">
                                <div class="text-right">
                                    <div class="text-white">Reserva <span class="ml-2 p-2 page-header--title">{{ solicitud }}</span></div>
                                    <p class="page-header--subtitle">Fecha<span class="ml-2 p-2 font-weight-bold ">{{ fechasol }}</span></p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </header>
                <!-- Fin encabezado contenido principal -->

                <!-- Cuerpo contenido principal -->
                <div class="container content-body">
                    <div class="row">
                        <!-- Bloque Personas-->
                        <div class="col-xl-4 mb-2">
                            <!-- Card Datos solicitante -->
                            <div class="card mb-2">
                                <div class="card-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>
                                    Datos del solicitante
                                </div>                            
                                <div class="card-body"> 
                                    <div class="form-row">                          
                                        <div class="form-group col-12">
                                            <label>Dirección</label>
                                            <input class="form-control" type="text" placeholder="Dirección" 
                                                v-model="EMP.dir"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressCp" type="text"
                                                placeholder="Cod.Postal" 
                                                v-model="EMP.cpo"/>
                                        </div>
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressPob" type="text"
                                                placeholder="Población" 
                                                v-model="EMP.pob"/>                                                        
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input class="form-control" id="empAddressPro" type="text"
                                                placeholder="Provincia" 
                                                v-model="EMP.pro"/>                                            
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="telTrabajo">Tel. Trabajo</label>
                                            <input class="form-control" id="telTrabajo" type="text"                                               
                                                v-model="EMP.tfnot"/>
                                        </div>
                                        <div class="form-group col">
                                            <label for="telParticular">Particular</label><input
                                                class="form-control" id="telParticular" type="text"                                            
                                                v-model="EMP.tfnop"/>
                                                
                                        </div>
                                        <div class="form-group col">
                                            <label for="telMovil">Móvil</label><input class="form-control"
                                                id="telMovil" type="text"                                                
                                                v-model="EMP.tfnom"/>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <label for="email">Email</label>
                                            <input class="form-control" id="empEmail" type="text"                                                
                                                v-model="EMP.email"/>
                                        </div>
                                    </div>                            
                                </div>
                            </div>
                            <!-- Fin Card Datos solicitante -->
                        </div>

                        <!-- Bloque Establecimientos y Observaciones -->
                        <div class="col-xl-8 mb-2">                            
                            <!-- Card Datos solicitante -->
                            <div class="card mb-1">
                                <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box mr-1" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg> Asistentes
                                    <div class="icons-actions ml-auto">  
                                        <b-button variant="dark" size="sm" class="mt-1 mr-2" @click="cerrar">
                                            <b-icon icon="x-circle" variant="light" aria-hidden="true"></b-icon> Cancelar
                                        </b-button>
                                        <b-button variant="success" size="sm" class="mt-1 mr-2" @click="grabar">
                                            <b-icon icon="check-circle" variant="light" aria-hidden="true"></b-icon> RESERVAR
                                        </b-button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="box mb-0">
                                        <div class="box-content p-1 ">
                                            <!-- Solicitante -->
                                            <div class="form-row">
                                                <div class="form-group col-5">
                                                    <label for="nombreSolicitante">Apellidos, Nombre</label>
                                                    <input class="form-control col" id="nombreSolicitante" type="text"
                                                        placeholder="Nombre Asistente" v-model="R.nom"/>
                                                </div>
                                                <div class="form-group col-2">
                                                    <label>DNI</label>
                                                    <b-form-input class="form-control" type="text" placeholder="DNI/Nif" v-model="R.nif"/>
                                                </div>                                                                                                
                                                <div class="form-group col-2">
                                                    <label for="matricula">Sexo</label>
                                                    <!-- <b-form-input class="form-control" type="text" v-model="R.sexo"/> -->
                                                    <b-form-select :options="sexo" size="sm" v-model="R.sexo"></b-form-select>  
                                                </div>
                                                <div class="form-group col-2">
                                                    <label for="matricula">Edad</label>
                                                    <!-- <b-form-input class="form-control" type="text" v-model="R.edad"/> -->
                                                    <b-form-select :options="edad" size="sm" v-model="R.edad"></b-form-select>  
                                                </div>                                                
                                            </div>                                                                                                                               
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Fin Card Datos solicitante -->

                            <div class="card mb-1">
                                <div class="card-header d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                        class="bi bi-box mr-1" viewBox="0 0 16 16">
                                        <path
                                            d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z" />
                                    </svg>Establecimiento Seleccionado
                                    <div class="icons-actions ml-auto">  
                                        <!-- <b-btn variant="primary" class="mt-1" size="sm" v-show="hotel.id>0">
                                            Reservar
                                        </b-btn>  -->                                        
                                        <b-btn variant="primary" class="mt-1" size="sm" v-show="hotel.id>0" @click="precios">
                                            Precio
                                        </b-btn>
                                        <b-btn variant="secondary" size="sm" class="mt-1 mx-2" @click="dispo">
                                            <b-icon icon="search" variant="light" aria-hidden="true"></b-icon> Disponibilidad
                                        </b-btn>
                                    </div>
                                </div>
                                <div class="card-body pt-1 px-1">                         
                                    <!-- 1 -->
                                    <div class="accommodation mb-0">    
                                        <div v-show="hotel.id>0">                                        
                                        <!-- <div> -->                                        
                                            <div class="form-group">
                                                <!-- <label>Establecimiento</label> -->
                                                <input disabled class="form-control" type="text" v-model="hotel.hotel"/>                                        
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-4">
                                                    <input disabled class="form-control" type="text" v-model="hotel.periodo"/>
                                                </div>
                                                <div class="col-5">
                                                    <input disabled class="form-control" type="text" v-model="hotel.tph"/>
                                                </div>
                                                <!-- <div class="col-3">                                                                                                        
                                                    <b-form-spinbutton class="ml-1 mt-1" size="sm" v-model="R.hab" min="1" max="3"/>
                                                </div> -->
                                                
                                            </div>                                               
                                        </div> 
                                    </div>                                                                                                        
                                </div>                                
                            </div>
                            <div class="card">
                                <div class="card-header">Observaciones</div>
                                <textarea class="mx-2 my-2 form-control" cols="30" rows="2" v-model="R.obs"/>                                                                    
                            </div>                                                    
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </main>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'vacantes',

 /*  props: {
        datos: { type:Object, default: null},        
  }, */
  
  data() {
    return { 
        modulo: 'VACANTES',
        
        plan:  2,
        xplan: "CAMPAMENTOS",

        sexo:[
            {value:'H', text:'Hombre'},
            {value:'M', text:'Mujer'},
        ], 
        edad:[
            {value:'3', text:'3'},
            {value:'4', text:'4'},
            {value:'5', text:'5'},
            {value:'6', text:'6'},
            {value:'7', text:'7'},
            {value:'8', text:'8'},
            {value:'9', text:'9'},
            {value:'10', text:'10'},
            {value:'11', text:'11'},
            {value:'12', text:'12'},
            {value:'13', text:'13'},
            {value:'14', text:'14'},
            {value:'15', text:'15'},
            {value:'16', text:'16'},
            {value:'17', text:'17'},
            {value:'18', text:'18'},
            {value:'19', text:'18'},
            {value:'20', text:'19'},
            {value:'21', text:'21'},
        ], 
        tpe: 0,        

        solicita: {
            items: [],
            fields: [                
                { key:'nom',label:'Nombre'},                
                { key:'nif',label:'DNI'},
                { key:'sexo',label:'Sexo'},
                { key:'edad',label:'Edad'},
            ],
        },       
                
        R: {},
        hab: 1,      
       
    }
  },

  created() {
  },

  mounted() {      
      this.leemos();      
  },

  computed: {
    ...mapState(['auth','hotel','fecha','EMP','ASI']),   

    logueado() {
        return this.auth.logueado;
    },   
    usuario() {
        return this.auth.user;
    },

    solicitud() {
        return this.R.id>0 ? this.R.id : 'NUEVA'
    },

    fechasol() {
        return !this.R.fecha>'' ? this.fecha : this.R.fecha;

    },

    //recuento
    PAX() {
        let Y=new Date().getFullYear();
        let p=1; let a=1; let n=0; let b=0; let aa=0; let nn=0;
        this.ASI.forEach(E => {
            if (Number(E.anac)>=Y-1) b++; 
            else {
                p++;            
                if (Number(E.anac)>=Y-12) n++; else a++;
                if (E.tp=='1') if (Number(E.anac)>=Y-12) nn++; else aa++;
            }
        });
        return {pax: p, adu: a, nin: n, bbs: b, adug: aa, ning: nn };
    }

  },

  methods: {   
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']), 
       
        async leemos() {

            //inicializamos datos
            this.$store.state.hotel={};
            this.R.hab=1;

            //this.plan=this.$route.name=='vacantes-campamentos' ?2:1;

            //this.loading();            
            let adj=this.$route.name=='vacantesNo' ?1:0;
            var args={ token: this.auth.token, plan: this.plan, adj: adj }            
            let r=await this.exec({api:'vacantes', arg: args });
            //this.loading(false);  

            if (r.error) {
                let m=r.datos;
                if (m=='Error Usuario (1)') {
                    m='La sesion iniciada se cerrará. Ha superado el tiempo de inactividad de su sesión.<br>Debe acceder de nuevo.';

                    this.$store.commit('login_off');
                    this.$router.push('/');
                } else
                    this.$router.push('/inicio');

                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.modulo, msg: m});             
                                                               
                return;
            }       
            
        },              
       
        async grabar() {
            console.log('**grabamos',this.EMP,this.ASI,this.R,this.hotel);            

            if (!this.validar()) return;           

            let msg="Estas Seguro RESERVAR Vacantes ?";
            let r=await this.$root.$msgConf(msg,'RESERVAS');
            if (!r) return;        
            
            this.R.con=this.hotel.id;
            this.R.hot=this.hotel.hot;

            this.R.adu=0; this.R.nin=1; this.R.bbs=0;            
            this.R.adug=0; this.R.ning=0;
            
            var args={ token: this.auth.token, plan: this.plan, fnt:'set', EMP: this.EMP, RES: this.R, ASI: this.ASI  }
            r=await this.exec({api:'reserva', arg: args });

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit: this.modulo, msg:r.datos});                
                return;
            }                                          

            this.modal({tit: this.modulo, msg:'Reserva Guardada Correctamente'});
            this.$router.push('/reservas'); 

        },

        validar() {        
            let S=this.hotel;
            let R=this.R; 
            let e1=0; let e2=0;

            let msg=''; 

            //asistente            
            if (!R.nom>'') msg+="<br>*Falta Apellidos, Nombre del Asistente";
            if (!R.nif>'') msg+="<br>*Falta DNI/NIF del Asistente";            

            //establecimiento
            if (!S.id>'') msg+='<br>Debes seleccionar un Establecimiento';

            if (S.mpax!=undefined) {
                e1=Number(S.mpax.split('-')[0]);
                e2=Number(S.mpax.split('-')[1]);
                if (Number(S.edad)<e1||Number(S.edad)>e2) 
                    msg+='<br>(1) Edad No Permitida en este establecimiento ( Edad entre ' +S.mpax+' años )';
            }            
            
            if (msg>'') {                
                this.modal({tit: this.modulo, msg: msg});
                return false;
            }
            return true;
        },        

        cerrar() {            
            this.$router.push('/inicio'); 
        },

        dispo() {
            this.$store.state.plan=this.plan;
            this.$bvModal.show("modal_hotelDispo");            
        },

        async precios() {
            /* if (!this.hotel.con>'') {
                this.modal({tit: this.modulo, msg:"Debes seleccionar Establecimiento / Turno ..."});                
                return;
            } */

            if (!this.validar()) return;

            this.R.con=this.hotel.id;
            this.R.hot=this.hotel.hot;
            this.R.adu=this.PAX.adu;            
            this.R.nin=this.PAX.nin;            
            this.R.bbs=this.PAX.bbs;            
            this.R.adug=this.PAX.adug; this.R.ning=this.PAX.ning;              

            let args={ token: this.auth.token, plan: 1, i: 0, S: this.R, C: this.hotel.con }
            let r=await this.exec({api:'calcula_precios', arg: args });
            console.log("*precios", r);
            
            let msg=''; //let A=[];
            if (r.error) msg=r.datos;
            else  {
                //A=this.$util.object_array(r.datos[0]);
                //A=this.$util.object_array(r);
            }
            msg="PRECIO ESTIMACION DE RESERVA:<br><br>" + 
                "Importe: &nbsp; &nbsp; &nbsp;<b> " + r.imp + "</b><br> " +
                "Subvención: &nbsp; <b> " + r.sub + "</b><br><br>" +
                "A PAGAR: &nbsp; &nbsp; &nbsp;<b> " + r.pag + "</b><br>";
            
            this.modal({tit: this.modulo, msg: msg, time: 0});                

        },

   }
}
</script>